import axios from 'axios'
import { Message } from 'element-ui'
// create an axios instance
const service = axios.create({
  baseURL: '/api'// 'http://10.15.12.64:6100',  //'http://2968391i5b.wicp.vip'  // process.env.VUE_APP_BASE_API, url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests //https://www.guanjiess.com.cn
  // timeout: 20000 //  timeout
})
// response interceptor
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.status === 200) {
      if (res.result === 0) {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        return res
      }
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    if (error.toString().endsWith('401')) {
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js